import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

import moment from "moment";

export const generatePayslipStructue = (rawData) => {
    const getIncrementAndDuration = (dates, dateKey, currentTotal) => {
        const allDates = Object.keys(dates).sort();
        const index = allDates.indexOf(dateKey);

        if (index <= 0) return { increment: "-", duration: "-" };

        const prevDate = allDates[index - 1];
        const prevItems = dates[prevDate];

        let prevEarn = 0;
        let prevDed = 0;

        prevItems.forEach((item) => {
            const amount = parseFloat(item.SALARYHEADS_AMOUNT) || 0;

            if (
                item.SALARY_HEAD_NAME?.toLowerCase().includes("deduction") ||
                item.SALARY_HEAD_NAME?.toLowerCase().includes("income tax") ||
                item.SALARY_HEAD_NAME?.toLowerCase().includes("loan")
            ) {
                prevDed += amount;
            } else {
                prevEarn += amount;
            }
        });

        const prevTotal = prevEarn - prevDed;

        const increment =
            prevTotal > 0 ? (((currentTotal - prevTotal) / prevTotal) * 100).toFixed(2) : "-";

        const duration = moment(dateKey).diff(moment(prevDate), "months") + " months";

        return { increment, duration };
    };

    const grouped = Object.entries(
        rawData.reduce((acc, item) => {
            const emp = item?.FIRSTNAME;
            const dateKey = moment(item?.ISSUE_DATE).format("YYYY-MM-DD");

            if (!acc[emp]) acc[emp] = {};
            if (!acc[emp][dateKey]) acc[emp][dateKey] = [];

            acc[emp][dateKey].push(item);
            return acc;
        }, {})
    );

    const doc = new jsPDF();
    doc.setFontSize(16);
    doc.text("Salary Structure Report", 14, 15);

    let y = 30;

    grouped.forEach(([name, dates]) => {

        // EMPLOYEE NAME
        doc.setFontSize(14);
        doc.text(`Employee: ${name}`, 14, y);
        y += 6;

        const rows = [];

        Object.entries(dates)?.forEach(([date, items]) => {
            let earning = 0;
            let deduction = 0;

            items.forEach((i) => {
                const amount = parseFloat(i?.SALARYHEADS_AMOUNT) || 0;

                if (
                    i?.SALARY_HEAD_NAME?.toLowerCase().includes("tax") ||
                    i?.SALARY_HEAD_NAME?.toLowerCase().includes("deduction") ||
                    i?.SALARY_HEAD_NAME?.toLowerCase().includes("loan")
                ) {
                    deduction += amount;
                } else {
                    earning += amount;
                }
            });

            let netTotal = earning - deduction;

            // 👇 NEW: Calculate Increment & Duration
            const { increment, duration } = getIncrementAndDuration(dates, date, netTotal);

            rows.push([
                moment(date).format("DD MMM YYYY"),
                `Rs ${earning?.toLocaleString("en-US")}`,
                `Rs ${deduction?.toLocaleString("en-US")}`,
                `Rs ${netTotal.toLocaleString("en-US")}`,
                `${increment}%`,      // NEW COLUMN 1
                duration              // NEW COLUMN 2
            ]);
        });


        autoTable(doc, {
            head: [["Date", "Earnings", "Deductions", "Net Total", "Increment %", "Duration"]],
            body: rows,
            startY: y,
            theme: "grid",
            headStyles: {
                fillColor: "#748084", // Blue-500
                textColor: 255,
                fontStyle: "bold"
            },
            styles: {
                cellPadding: 3,
            }
        });

        y = doc.lastAutoTable.finalY + 12;

        if (y > 260) {
            doc.addPage();
            y = 20;
        }
    });

    doc.save("Salary_Structure_Report.pdf");
};
